import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { umkreisMitKm } from '../../../../shared/utils/umkreis-mit-km.util';
import { map } from 'rxjs';
import { UmkreisFacettenService } from '../../../../services/facetten/instance/umkreis-facetten.service';
import { OrtService } from '../../../../services/suchseite/ort.service';
import { RangeSliderComponent } from '../../../range-slider/range-slider.component';

@Component({
  selector: 'now-wbsuche-lib-ort-suchumkreis',
  templateUrl: './ort-suchumkreis.component.html',
  styleUrl: './ort-suchumkreis.component.scss',
  imports: [RangeSliderComponent]
})
export class OrtSuchumkreisComponent {
  private readonly umkreisFacettenService = inject(UmkreisFacettenService);
  private readonly ortService = inject(OrtService);

  public umkreisLabelFunction = umkreisMitKm;
  public range = OrtService.suchumkreisRange;

  umkreistStringToId(umkreisString: string | null): number {
    if (!umkreisString) {
      return 0;
    }
    try {
      return this.range.indexOf(umkreisString);
    } catch (e) {
      return 0;
    }
  }

  umkreisIdToValue(id: number | undefined): string {
    if (id === undefined) {
      return this.range[0];
    }
    try {
      return this.range[id];
    } catch (e) {
      return this.range[0];
    }
  }

  public suchumkreis$ = this.ortService.umkreis$;
  public suchumkreisAsId = toSignal(
    this.suchumkreis$.pipe(map((umkreisString) => this.umkreistStringToId(umkreisString)))
  );
  public disabled = toSignal(this.ortService.ort$.pipe(map((ort) => !ort)));

  public async onSelectionChangedSlider(event: any) {
    const umkreisOptionId = event.target.value;
    const umkreis = this.umkreisIdToValue(umkreisOptionId);
    this.umkreisFacettenService.setUmkreis(umkreis);
  }
}
